// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes spin-data-v-3958253a{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.preloader[data-v-3958253a]{width:100%;min-height:300px;display:flex;align-items:center}.preloader .spinner[data-v-3958253a]{margin-left:5px;padding:5px;border:5px solid var(--q4s-neutral-400);border-top:5px solid var(--q4s-accent);border-radius:50%;animation:spin-data-v-3958253a 2s linear infinite}", ""]);
// Exports
module.exports = exports;
